// extracted by mini-css-extract-plugin
export var category = "_kr-9";
export var categoryHeader = "_kr-e";
export var container = "_kr-0";
export var group = "_kr-a";
export var groupItems = "_kr-f";
export var groupSeparator = "_kr-j";
export var loading = "_kr-1";
export var noResults = "_kr-3";
export var placeholder = "_kr-2";
export var resultContent = "_kr-5";
export var resultIcon = "_kr-c";
export var resultItem = "_kr-g";
export var resultMeta = "_kr-8";
export var resultSubtitle = "_kr-7";
export var resultSuffix = "_kr-i";
export var resultTitle = "_kr-6";
export var resultsList = "_kr-4";
export var searchGroup = "_kr-d";
export var selected = "_kr-h";
export var subgroup = "_kr-b";